import { render, staticRenderFns } from "./OnlineOrderBoard.vue?vue&type=template&id=1406a5db&scoped=true"
import script from "./OnlineOrderBoard.vue?vue&type=script&lang=js"
export * from "./OnlineOrderBoard.vue?vue&type=script&lang=js"
import style0 from "./OnlineOrderBoard.vue?vue&type=style&index=0&id=1406a5db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1406a5db",
  null
  
)

export default component.exports